import React from "react";
import ReactPlayer from "react-player";
const concertsRecords = () => {
  const concertArray = [
    {
      url:
        "https://soundcloud.com/zhan-y-ld-z/saniser-kocaeli-konseri-sokrat-st-11120",
      title: "Şanışer Kocaeli Concert ",
      date: "12.1.20",
      comment:
        "In January,2020 Şanışer had come to Kocaeli.The moment very important for me."
    },
    {
      url:
        "https://soundcloud.com/zhan-y-ld-z/saniser-bursa-konseri-dogum-gunum-270719",
      title: "Şanışer",
      date: "27.7.18",
      comment:
        "In January,2020 Şanışer had come to Kocaeli.The moment very important for me."
    },
    {
      url:
        "https://soundcloud.com/zhan-y-ld-z-797572552/oscar-and-the-wolf-concert-in-istanbul-220619",
      title: "Oscar and the Wolf",
      date: "11.6.19"
    },
    {
      url:
        "https://soundcloud.com/zhan-y-ld-z/saniser-bursa-konseri-dogum-gunum-270719",
      title: "Şanışer",
      date: "27.7.19"
    }
  ];

  return (
    <div className="blog-container">
      {concertArray.map(concert => (
        <div className="card-records">
          <ReactPlayer
            className="player"
            url={concert.url}
            width="70vh"
            height="40vh"
          />
          <a>{concert.title}</a>
          <p>
            {concert.comment}
            Send me invite link on your accounts.Publish oyur
            projects.Enjoys.Have a nice day..Click this social media icons plss
          </p>
          <i class="fas fa-calendar-alt">{concert.date}</i>
        </div>
      ))}
    </div>
  );
};

export default concertsRecords;
